"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConstructorInitialConfig = void 0;

var _utils = require("../../../utils");

/**
 * @desc конфиг контекста по умолчанию
 * */
var createConstructorInitialConfig = function createConstructorInitialConfig() {
  return {
    widgetName: undefined,
    partnerKey: (0, _utils.getPartnerKey)(),
    whitelabelDomain: (0, _utils.getWhitelabelDomain)(),
    whitelabelName: (0, _utils.getWhitelabelName)(),
    whitelabelLogo: (0, _utils.getWhitelabelLogo)(),
    redirect: '_blank',
    isWhitelabel: (0, _utils.getWhitelabelName)() !== 'LT'
  };
};

exports.createConstructorInitialConfig = createConstructorInitialConfig;